import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import { toast } from "react-toastify";
import Toggler from "../../../components/Toggler";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const ThumbnailSettings = (props) => {


  const access_token = localStorage.getItem("access_token");
  const headers = { "Content-Type": "application/json", Authorization: "Bearer " + access_token, Accept: "application/json", "Access-Control-Allow-Origin": "*", };
  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const fileInputRef1 = useRef(null);

  const [loading, setLoading] = useState(true);
  const [domLoad, setDomLoad] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectedFile1, setSelectedFile1] = useState(null);

  const [setting, setSetting] = useState({
    title: 1,
    age: 1,
    rating: 1,
    published_year: 1,
    published_on: 1,
    duration: 1,
    category: 1,
    featured: 1,
    free_or_cost_label: 1,
    reels_videos: 1,
    trailer: 1,
    description: 1,
    play_button: "",
  });



  useEffect(async () => {
    await axios
      .get(`${process.env.REACT_APP_Baseurl}/admin/Thumbnail-Setting/index`, {
        headers: headers,
      })
      .then((response) => {
        var data = response?.data?.Thumbnail_Setting;
        setSetting(data);
        setShowOverlay(false);
      })
      .catch((error) => setShowOverlay(false));
  }, [domLoad]);


  const handleFileChange = (event, fileInputRef, setSelectedFile) => {
    const file = event.target.files[0];
    if (!file) return;
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    if (!validTypes.includes(file.type)) {
      toast.error("Only JPG, JPEG, and PNG files are allowed.")
      fileInputRef.current.value = "";
      return;
    }
    setSelectedFile(file);
  };

  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const handleInput = (e) => {
    setSetting({ ...setting, [e.target.name]: e.target.value });
    if (e.target.checked === true) {
      setSetting({ ...setting, [e.target.name]: 1 });
    } else {
      setSetting({ ...setting, [e.target.name]: 0 });
    }
  };


  const handleUpdate = async () => {
    const formData = new FormData();

    const title = Number.isNaN(parseInt(setting?.title, 10)) ? 0 : parseInt(setting?.title, 10);
    formData.append("title", title);
    const reels_videos = Number.isNaN(parseInt(setting?.reels_videos, 10)) ? 0 : parseInt(setting?.reels_videos, 10);
    formData.append("reels_videos", reels_videos);
    const trailer = Number.isNaN(parseInt(setting?.trailer, 10)) ? 0 : parseInt(setting?.trailer, 10);
    formData.append("trailer", trailer);
    const age = Number.isNaN(parseInt(setting?.age, 10)) ? 0 : parseInt(setting?.age, 10);
    formData.append("age", age);
    const rating = Number.isNaN(parseInt(setting?.rating, 10)) ? 0 : parseInt(setting?.rating, 10);
    formData.append("rating", rating);
    const published_year = Number.isNaN(parseInt(setting?.published_year, 10)) ? 0 : parseInt(setting?.published_year, 10);
    formData.append("published_year", published_year);
    const published_on = Number.isNaN(parseInt(setting?.published_on, 10)) ? 0 : parseInt(setting?.published_on, 10);
    formData.append("published_on", published_on);
    const duration = Number.isNaN(parseInt(setting?.duration, 10)) ? 0 : parseInt(setting?.duration, 10);
    formData.append("duration", duration);
    const category = Number.isNaN(parseInt(setting?.category, 10)) ? 0 : parseInt(setting?.category, 10);
    formData.append("category", category);
    const featured = Number.isNaN(parseInt(setting?.featured, 10)) ? 0 : parseInt(setting?.featured, 10);
    formData.append("featured", featured);
    // formData.append("image", selectedFile1);
    const free_or_cost_label = Number.isNaN(parseInt(setting?.free_or_cost_label, 10)) ? 0 : parseInt(setting?.free_or_cost_label, 10);
    formData.append("free_or_cost_label", free_or_cost_label);
    const description = Number.isNaN(parseInt(setting?.description, 10)) ? 0 : parseInt(setting?.description, 10);
    formData.append("description", description);
    setShowOverlay(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/admin/Thumbnail-Setting/update`, formData, { headers: headers });
      if (response.data.status) {
        const id = response.data?.Thumbnail_Setting?.id;
        if (selectedFile1) {
          const modelName = "ThumbnailSetting";
          const imageFields = ["play_button"];
          const imageFormData = new FormData();
          imageFormData.append("id", id);
          imageFormData.append("modelName", modelName);
          imageFields.forEach((field) => {
            imageFormData.append("imageFields[]", field);
          });
          imageFormData.append("play_button", selectedFile1);
          await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: imageFormData,
          });
        }
        toast.success(response?.data?.message)
        setShowOverlay(false)
        setDomLoad(!domLoad)
        setSelectedFile1(null)
      }
    } catch (error) {
      toast.error(error?.response?.data?.message)
      setShowOverlay(false)
    }
  }

  return (
    <>

      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={"Thumbnail Settings"} saveText={"Update Settings"} saveMethod={handleUpdate} />

      <FormContainer>
        <Wrapper className={"w-100"}>

          <table style={{ width: "100%" }} >
            <thead>
              <tr className="title">
                <th>
                  <MessageHeading text={"Name"} />
                </th>
                <th>
                  <MessageHeading text={"Status"} />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><MessageLabel text={"Enable for Title"} /></td>
                <td><AdminSwitch name={'title'} checked={Number(setting?.title) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Age"} />   </td>
                <td><AdminSwitch name={'age'} checked={Number(setting?.age) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Rating"} /></td>
                <td> <AdminSwitch name={'rating'} checked={Number(setting?.rating) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Published Year"} /></td>
                <td> <AdminSwitch name={'published_year'} checked={Number(setting?.published_year) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Published ON"} /></td>
                <td> <AdminSwitch name={'published_on'} checked={Number(setting?.published_on) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Duration"} /></td>
                <td> <AdminSwitch name={'duration'} checked={Number(setting?.duration) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Featured"} /></td>
                <td> <AdminSwitch name={'featured'} checked={Number(setting?.featured) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Free or Cost Label"} /></td>
                <td> <AdminSwitch name={'free_or_cost_label'} checked={Number(setting?.free_or_cost_label) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Category"} /></td>
                <td> <AdminSwitch name={'category'} checked={Number(setting?.category) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Trailer"} /></td>
                <td> <AdminSwitch name={'trailer'} checked={Number(setting?.trailer) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Reels Videos"} /></td>
                <td> <AdminSwitch name={'reels_videos'} checked={Number(setting?.reels_videos) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Enable for Descriptions"} /></td>
                <td> <AdminSwitch name={'description'} checked={Number(setting?.description) === 1} onChange={handleInput} /></td>
              </tr>
              <tr>
                <td><MessageLabel text={"Play Button Image"} /></td>
                <td>
                  <div className="mt-1 text-center">
                    <div className="">
                      <img id="thumbnail-play-button"
                        src={setting?.play_button}
                        alt="Image"
                        className="thumbnails-images"
                      />
                    </div>

                    <div className="col-lg-12 row mt-2">
                      <div className="col-6 col-sm-6 col-lg-6">
                        <div
                          className="imagedrop"
                          onClick={() => fileInputRef1.current.click()}
                        >
                          <input
                            type="file"
                            ref={fileInputRef1}
                            onChange={(event) =>
                              handleFileChange(
                                event,
                                fileInputRef1,
                                setSelectedFile1
                              )
                            }
                            accept="image/jpeg, image/png, image/gif, image/webp"
                            style={{ display: "none" }}
                          />
                          <label>
                            <CameraRetroIcon />
                          </label>
                        </div>
                      </div>
                      <div className="col-6 col-sm-6 col-lg-6">
                        <div>
                          {selectedFile1 && (
                            <div className="imagedropcopy text-end">
                              <div className="col-lg-12 row p-0 m-0">
                                <div className=" col-sm-10 col-lg-10 p-0 m-0">
                                  <img
                                    src={URL.createObjectURL(
                                      selectedFile1
                                    )}
                                    alt="Uploaded"
                                    className="thumbnails-upload-images"
                                  />
                                </div>
                                <div
                                  className="col-sm-2 col-lg-2 p-0 m-0"
                                  style={{ alignSelf: "center" }}
                                >
                                  <button
                                    onClick={() => handleDelete(1)}
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                  ></button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Wrapper>
      </FormContainer>
    </>
  );
}

export default ThumbnailSettings;
